import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { buildTicketReassignmentItineraryColumns } from '../../../../../../config/columns';
import Table from '../../../../../common/Table';
import TicketReassignmentModal from './TicketReassignmentModal';
import { WRITE } from '../../../../../../config/permissions';
import { TICKET_REASSIGNMENT_ENDPOINT } from '../../../../../../config/endpoints';

const TicketReassignmentTable = ({
  ticketReassignments,
  loading,
  itineraryId,
  securityProfiles,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState(null);
  const [selected, setSelected] = useState(null);

  const handleView = ({ id, item }) => {
    setMode('view');
    setSelected({ id, item });
    setModalOpen(true);
  };

  const handleEdit = ({ id, item }) => {
    setMode('edit');
    setSelected({ id, item });
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setMode(null);
    setSelected(null);
  };

  const canSeePostSale =
    securityProfiles &&
    securityProfiles.some((profile) =>
      profile.authorizedEndpointList.some(
        (auth) =>
          auth.endpoint &&
          auth.endpoint.route !== '.*' &&
          TICKET_REASSIGNMENT_ENDPOINT.match(auth.endpoint.route) &&
          auth.endpoint.permissionType === WRITE,
      ),
    );

  const columns = useMemo(
    () =>
      buildTicketReassignmentItineraryColumns({
        onView: handleView,
        onEdit: handleEdit,
        canSeePostSale,
      }),
    [],
  );

  return (
    <div className="mb-3">
      <Table
        columns={columns}
        data={ticketReassignments}
        loading={loading}
        defaultPageSize={
          ticketReassignments.length > 10 ? 10 : ticketReassignments.length
        }
        showPagination={ticketReassignments.length > 10}
      />

      <TicketReassignmentModal
        open={modalOpen}
        mode={mode}
        data={selected}
        onClose={handleClose}
        itineraryId={itineraryId}
      />
    </div>
  );
};

TicketReassignmentTable.propTypes = {
  ticketReassignments: PropTypes.arrayOf(
    PropTypes.shape({
      Header: PropTypes.string,
      accessor: PropTypes.string,
    }),
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  securityProfiles: PropTypes.arrayOf(
    PropTypes.shape({
      authorizedEndpointList: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          endpoint: PropTypes.shape({
            id: PropTypes.number.isRequired,
            route: PropTypes.string.isRequired,
            permissionType: PropTypes.string.isRequired,
          }),
        }),
      ),
    }),
  ).isRequired,
};

TicketReassignmentTable.defaultProps = {
  itineraryId: null,
};

const mapStateToProps = ({ authentication }) => ({
  securityProfiles: authentication.get('user').securityProfileSet,
});

export default connect(mapStateToProps)(TicketReassignmentTable);
